import React from 'react'
import axios from 'axios'
const token = `Bearer ${window.localStorage.token}`
const { REACT_API_KEY } = process.env
const createInstance = (args) => {
  const { method, url, headers, data, params, ...other } = args
  return axios({
    url: url,
    method: method,
    headers: {
      'Api-Key': '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
      Authorization: token,
      ...headers
    },
    params,
    data,
    ...other
  }).catch(error => {
    // if (error) {
    //   localStorage.removeItem('token')
    //   window.location.reload()
    // }
  })
}
export default createInstance
